<template>
    <div class="max-w-screen-xl max-h-screen-tablet-cross-axis mx-auto py-2 overflow-x-hidden" v-on:click="click">
        <div v-if="seconds == 0" class=" sticky top-0 dark:sticy-header-background" style="z-index: 99;">
            <Header :back="false" :language="postsData.lang" @langchanged="langchanged_" :languageVisibility="false" @modeChanged="modeChanged"/>
            <div class="text-center flex flex-col justify-center h-3/5">
                <img :src="logo" alt="Logo" class="w-44 mx-auto">
                <h2 class="font-heading text-h2 text-redDamask dark:text-redDamask mt-10 mb-2">{{ $t('language.selectTitle') }}</h2>
                <p class="font-body text-bodyM text-sepiaBlack dark:text-halfColonialWhite">{{ $t('language.text') }}</p>
                <Language flag tablet :language="postsData.lang" @langchanged="langchanged_" class="mt-6"/>
                <Button xl :text="$t('language.saveBtn')" buttonType="primary" v-on:click="startTimer" fullWidth class="mt-24"/>
            </div>
        </div>
        <section v-else>
            <Header :back="false" :language="postsData.lang" 
                @langchanged="langchanged_"
                :modeChanged="modeChanged">
            </Header>
            <ul class="grid 2xl:grid-cols-4 tablet:grid-cols-3 md:grid-cols-2 gap-x-1 justify-items-center">
                <li v-for="post of posts" :key="post.id">
                    <EntityList :content="post" />
                </li>
            </ul>
            <pagination :pagination="pagination"
                @prev="--postsData.page; getPosts();"
                @next="postsData.page++; getPosts();">
            </pagination>
        </section>
    </div>
</template>

<script>

import Header from "@/components/Header.vue";
import pagination from "@/components/Pagination.vue";
import EntityList from "@/components/tablet/EntityList.vue";
import Button from '@/components/Button.vue';
import Language from '@/components/Language';

export default {
    name: "Tablet",
    components: {
        Header,
        'pagination': pagination,
        EntityList,
        Button,
        Language,
    },
    mounted() {
        this.$i18n.locale = this.lang;
        localStorage.setItem('tablet_category', this.$route.query.category ? this.$route.query.category : '');
        const query_seconds = this.$route.query.seconds;
        if (query_seconds) {
            if (query_seconds == 0) {
                this.seconds = 0;
            } else {
                this.startTimer();
            }
        } else {
            this.seconds = 0;
        }

        this.getPosts();
        this.getLogo();
    },
    data(){
        return {
            lang: localStorage.getItem('language') ? localStorage.getItem('language') : 'ro',
            posts: [],
            baseURL: process.env.VUE_APP_AXIOS_URL,
            postsData: {
                per_page: 8,
                page: 1,
                lang: localStorage.getItem('language') ? localStorage.getItem('language') : 'ro',
                search: '',
                category: '',
            },
            pagination: {
                prevPage: '',
                nextPage: '',
                totalPages: '',
                from: '',
                to: '',
                total: '',
            },
            seconds: 0,
            standard_sec: 60,
            logo: '',
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        getPosts() {
            this.postsData.category = this.$route.query.category;
            this.axios.get(this.baseURL + `/wp-json/wp/v2/tablets`, {params: this.postsData}, {
                headers: {
                        'Access-Control-Allow-Origin': '*'
                }
            }).then(response => {
                this.posts = response.data;
                this.configPagination(response.headers);
            }).catch( (error) => {
                // console.log(error);
            });
        },
        configPagination(headers) {
            this.pagination.total = +headers['x-wp-total'];
            this.pagination.totalPages = +headers['x-wp-totalpages'];
            this.pagination.from = this.pagination.total ? ((this.postsData.page - 1) * this.postsData.per_page) + 1 : ' ';
            this.pagination.to = (this.postsData.page * this.postsData.per_page) > this.pagination.total ? this.pagination.total : this.postsData.page * this.postsData.per_page;
            this.pagination.prevPage = this.postsData.page > 1 ? this.postsData.page : '';
            this.pagination.nextPage = this.postsData.page < this.pagination.totalPages ? this.postsData.page + 1 : '';
        },
        langchanged_(value) {
            this.postsData.page = 1;
            this.postsData.lang = value;
            this.getPosts();
        },
        startTimer() {
            this.$router.replace({ query: {seconds: "60", category: this.$route.query.category} })
            this.seconds = this.standard_sec;
            setTimeout(this.countdown, 1000);
        },
        countdown() {
            // console.log(this.seconds);
            if (this.seconds > 0) {
                this.seconds -= 1;
                setTimeout(this.countdown, 1000);
            }
        },
        click() {
            if (this.seconds > 0) {
                this.seconds = this.standard_sec;
            }
        },
        handleScroll (event) {
            if (this.seconds > 0) {
                this.seconds = this.standard_sec;
            }
        },
        getLogo: function() {
            const element = document.getElementById("app");
            if (element.classList.contains('darkMode')) {
                this.logo = require("../assets/logo_dark.png");
            } else {
                this.logo = require("../assets/logo_light.png");
            }
        },
        modeChanged(value) {
            this.getLogoAfterChange(value);
        },
        getLogoAfterChange(value) {
            if (value == 'dark') {
                this.logo = require("../assets/logo_dark.png");
            } else {
                this.logo = require("../assets/logo_light.png");
            }
        },
    },
};
</script>
